import { render, staticRenderFns } from "./ViewMessage.vue?vue&type=template&id=e02a19be&scoped=true&"
import script from "./ViewMessage.vue?vue&type=script&lang=js&"
export * from "./ViewMessage.vue?vue&type=script&lang=js&"
import style0 from "./ViewMessage.vue?vue&type=style&index=0&id=e02a19be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e02a19be",
  null
  
)

export default component.exports